<template lang="pug">
  .card.mb-0
    .card-body
      .row
        .col-12.mb-1
          h2.section-title.mt-0 {{ id }} ({{ $moment(date.startDate).format('YYYY-MM-DD') }})
        .col-10.mb-1
          b-pagination.float-left(
            size="sm"
            hide-ellipsis
            :total-rows="totalRowOperator"
            :per-page="getPageSize"
            v-model="currentPageOperator"
            @input="changedPageOperator($event)")
        .col-2.mb-1
          b-input-group(:prepend="$t('ui.page_size')" size="sm")
            b-form-select(:options="$store.getters.pageSizeOptions" :value="getPageSize" @input="changedPageSizeOperator" size="sm")
        .col-6(style="max-height: 70vh; overflow: hidden;")
          .clusterize-scroll.table-responsive
            table.table.table-sm.table-bordered.table-striped.table-hover.table-align-middle
              thead.thead-light
                tr
                  th.text-center(width="3%")
                    span #
                  th(width="10%" @click="sortOrderOperator('module')")
                    span(:title="$t('ui.module')") {{ $t('ui.module') }}
                    .float-right
                      i(:class="changeSortKeyOperator('module')")
                  th.text-center(width="11%" @click="sortOrderOperator('sms_count')")
                    span(:title="$t('ui.sms_count')") {{ $t('ui.sms_count') }}
                    .float-right
                      i(:class="changeSortKeyOperator('sms_count')")
              tbody.clusterize-content
                tr(v-if="list.length == 0")
                  td(colspan="3").text-center
                    span {{ $t('message.no_data_available') }}
                tr(v-for="(item, index) in list")
                  td.text-center
                    span(:title="((currentPageOperator - 1) * getPageSize + index + 1)") {{ ((currentPageOperator - 1) * getPageSize + index + 1) }}
                  td
                    span(:title="item.module") {{ item.module }}
                  td.text-center
                    span(:title="item.sms_count") {{ item.sms_count }}
                tr(v-if="showTotal")
                  td.text-right(colspan="2")
                    div.d-block {{ $t("ui.sub_total") }}
                    div {{ $t("ui.grand_total") }}
                  td.text-center
                    .font-weight-bold.d-block(:class="$helpers.fontClassName(subTotalSMSCount)" :title="subTotalSMSCount") {{ subTotalSMSCount }}
                    .font-weight-bold(:class="$helpers.fontClassName(grandTotalSMSCount)" :title="grandTotalSMSCount") {{ grandTotalSMSCount }}

  </template>

<script>
  import config from "@/config";
  import errorTags from "@/errorTags";
  import SubmitButton from "@/library/SubmitButton.vue";
  import DebounceInput from "@/library/DebounceInput";

  export default {
    components: {
      SubmitButton,
      DebounceInput
    },
    props: {
      id: {
        type: String,
        default: ''
      },
      date: {
        type: Object,
        default: ""
      },
    },
    data: () => ({
      loading: false,
      list: [],
      subTotalSMSCount: 0,
      grandTotalSMSCount: 0,
      showTotal: false,
      feedback: {
        success: false,
        status: errorTags.request.failed
      },

      sortKey: "working_date",
      sortType: "desc",
      currentPageOperator: 1,
      totalRowOperator: 0,
    }),
    computed: {
      getPageSize() {
        return this.$store.getters.pageSize;
      },
    },
    mounted: function() {  },
    methods: {
      sortOrderOperator(key) {
        if (this.sortKey == key)
          this.sortType = this.sortType == 'asc' ? 'desc' : 'asc';
        else {
          this.sortKey = key;
          this.sortType = 'asc';
        }

        this.getList(true);
      },
      changeSortKeyOperator(key) {
        if (this.sortKey != key)
          return 'fas fa-sort';
        else if (this.sortKey == key && this.sortType == 'asc')
          return 'fa fa-sort-up';
        else if (this.sortKey == key && this.sortType == 'desc')
          return 'fa fa-sort-down';
      },
      getList: function(isSearch) {
        let url = config.dailySummarySMSOperatorDetailUrl();
  
        if (isSearch) this.currentPageOperator = 1;
  
        var json = {
          action_by: this.$store.getters.loginId,
          auth_token: this.$store.getters.sessionToken,
          operator_id: this.id,
          working_date: this.date.startDate,
          sort_type: this.sortType,
          page_number: this.currentPageOperator,
          page_size: this.getPageSize
        };
  
        this.loading = true;
        this.$http.post(url, json).then(
          function(response) {
            this.loading = false;
            // Success
            try {
              if (response) {
                this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;
  
                this.feedback.status = response.data.statusdesc;
                if (this.feedback.success == true) {
                  if(response.data.ds.smslist.length > 0) {
                    this.list = response.data.ds;
                    this.showTotal = true;
                    response.data.ds.smslist.forEach(value => {
                      this.subTotalSMSCount = parseFloat(this.subTotalSMSCount) + parseFloat(value["sms_count"]);
                    });


                    if(response.data.ds.grand_total.length > 0) {
                      this.grandTotalSMSCount = response.data.ds.grand_total[0]["sms_count"];
                    }

                    this.list = response.data.ds.smslist;
                    this.totalRowOperator = response.data.ds.smslist.length > 0 ? this.list[0]["totalrows"] : 0
                  } else {
                    this.clearTotal()
                  }
                } else {
                  this.clearTotal()
                  if (this.feedback.status != 'permission_denied') {
                    if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
                  }
                  else {
                    this.$helpers.showToast(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
                  }
                }
              }
            } catch (error) {
              this.feedback.success = false;
              this.feedback.status = errorTags.request.failed;
              this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
            }
          },
          function(response) {
            this.loading = false;
            // Error
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        );
      },
      clearTotal() {
        this.showTotal = false
        this.list = []
        this.totalRowOperator = 0
        this.subTotalSMSCount = 0
        this.grandTotalSMSCount = 0
      },
      changedPageSizeOperator: function(pageSize) {
        this.$store.dispatch("layout/setPageSize", pageSize);
        this.currentPage = 1;
        this.getList(true);
      },
      changedPageOperator: function(pageNo) {
        this.currentPage = pageNo;
        this.getList();
      },
      handleFailed: function(tag, status) {
        this.$helpers.showDialog(this.$t("ui.combine." + tag), this.$t("error." + status), "error");
      }
    }
  };
  </script>